import script from "./StudentReleaseConfirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentReleaseConfirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./StudentReleaseConfirmDialog.vue?vue&type=style&index=0&id=498cc124&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-498cc124"]])

export default __exports__